<template>
    <v-container fluid>
        <form-component
            v-if="planPackage"
            :planPackage="planPackage"
            :isEdit="false"
            :titlePrefix="$t('form.add-prefix')"
            @saved="onSaved"
        />
        <v-container v-else fluid class="fill-height">
            <v-row justify="center" align="center">
                <v-col class="text-center" xs="12" md="12">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    />
                </v-col>
            </v-row>
        </v-container>
    </v-container>
</template>

<script>
import PlanPackage from '@/models/plans/PlanPackage'
import FormComponent from './Form.vue'

export default {
    components: {
        'form-component': FormComponent,
    },

    data: () => ({ planPackage: null }),

    created() {
        this.planPackage = new PlanPackage()
    },

    methods: {
        onSaved() {
            this.$router.push({ name: 'planPackages.index' })
        },
    },
}
</script>
